import React from 'react'
import { useParams } from 'react-router'

import EditorAwareExport from 'src/editor/build-tools/exporter'

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import PrimaryCTA from 'shared/components/primary_cta/PrimaryCTA'

import { CTAData, getCtaContent } from 'public/components/default_template/ctas'

type Props = {
  primaryCta?: CTAData | null
  customTheme?: boolean
}

const ClientStickyFooter = ({ primaryCta, ...props }: Props) => {
  const params = useParams<{ slug?: string }>() // this call cannot be in the editor
  return (
    <StickyFooterView slug={params.slug} primaryCta={primaryCta} {...props} />
  )
}

const EditorStickyFooter = ({ primaryCta, ...props }: Props) => {
  return <StickyFooterView primaryCta={primaryCta} {...props} />
}

type FooterCTAProps = {
  primaryCta?: CTAData | null
  slug?: string
  customTheme?: boolean
}

/** The underlying view component that is compatible in both the client and editor bundle. */
const StickyFooterView = ({
  primaryCta,
  slug,
  customTheme = false
}: FooterCTAProps) => {
  const {
    restaurant,
    orderingUrl,
    reservationsUrl,
    phoneNumber,
    selectedLocation
  } = useRestaurant()
  const showLocationNames: boolean = !!restaurant?.config.showLocationNames
  const sameTab = !!restaurant.content?.navConfig?.openExternalLinksInSameTab

  const ctaProps = {
    restaurantConfig: restaurant.config,
    orderingUrl,
    reservationsUrl,
    phoneNumber,
    selectedLocation: slug ? selectedLocation : undefined
  }

  const primaryCtaContent = primaryCta
    ? getCtaContent(primaryCta, showLocationNames, ctaProps)
    : null

  if (!primaryCtaContent) {
    return null
  }

  return (
    <div
      className={`${customTheme ? 'customStickyFooter' : 'stickyFooter'}`}
      data-testid='sticky-footer-wrapper'
    >
      <PrimaryCTA
        sameTab={sameTab}
        href={primaryCtaContent.link}
        text={primaryCtaContent.text}
        onClick={primaryCtaContent.onClick}
      />
    </div>
  )
}

export default EditorAwareExport(ClientStickyFooter, EditorStickyFooter)
